import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CxDatagridComponent } from "./cx-datagrid.component";
import { CxTableTemplate } from "./directives/cx-table-template.directive";
import { CxTableService } from "./services/cx-table.service";
import { CxSplitCommaPipe } from "./pipes/cx-split-comma.pipe";
import { CxColumnSortDirective } from "./directives/cx-column.sort.directive";
import { CxColumnFrozenDirective } from "./directives/cx-column.frozen.directive";
import { ColumnResizeDirective } from "./directives/cx-column-resize.directive";
import { DropdownModule } from '@shared/modules/dropdown/dropdown';
import { CxAdvFiltersModule } from "@shared/modules/cx-adv-filters/cx-adv-filters.module";
import { EditModalComponent } from "./modal/edit-column/edit-column-modal.component";
import { ColumnEditDirective } from "./directives/cx-edit-column.directive";
import { ColumnSelectionDirective } from "./directives/cx-selection-column.directive";
import { FormsModule } from "@angular/forms";
import { ExportModalComponent } from "./modal/export/export-modal.component";
import { CxSchedularModule } from "@shared/modules/cx-schedular/cx-schedular.module";
import { DynamicDialogModule } from '@shared/modules/dynamicdialog';
import { DialogModule } from "../dialog/dialog";
import { CxDatagridSettingsComponent } from "./settings/cx-datagrid-settings.component";
import { CdkDrag, CdkDropList, CdkDragPlaceholder, CdkDropListGroup } from "@angular/cdk/drag-drop";
import { ChipsModule } from "../chips/chips";
import { AdvanceDateRangeModule } from "../../components/advance-daterangepicker/advance-daterangepicker.module";
import { MultiSelectModule } from "../multiselect/multiselect";
import { PaginationModule } from "../pagination/pagination.module";
import { CxDataGridService } from "./cx-datagrid.service";
import { CxShowablePipe } from "./pipes/cx-only-showable.pipe";
import { EditViewNameModalComponent } from "./modal/edit-viewname/edit-viewname-modal.component";
import { CxFrozenColumn } from "./pipes/cx-only-frozen-column.pipe";
import { CxSplicePipe } from "./pipes/cx-splice.pipe";
import { TooltipModule } from '../tooltip/tooltip';
import { OverlayPanelModule } from "../overlaypanel/overlaypanel";
import { CxNestedRead } from "./pipes/cx-nested-read.pipe";
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AddEvaluationActionDirective } from "./directives/cx-add-evaluation-action.directive";
import { AgentCallEvaluationFormComponent } from "../../features/insight/agent-calls-evaluation/agent-call-evaluation-form/agent-call-evaluation-form.component";
import { ViewEvaluationActionDirective } from "./directives/cx-view-evaluation-action.directive";
import { ShowTranscriptActionDirective } from "./directives/cx-show-transcript-action.directive";
import { AgentCallRecordingTranscriptComponent } from "../../features/insight/agent-calls-evaluation/agent-call-recording-transcript/agent-call-recording-transcript.component";
import { ViewSubmittedEvaluationActionDirective } from "./directives/cx-view-submitted-evaluation-action.directive";

@NgModule({
    imports: [ 
        CdkDragPlaceholder, CdkDropList, CdkDropListGroup, 
        CdkDrag, OverlayPanelModule, TooltipModule, ChipsModule, 
        CxSchedularModule, PaginationModule, AdvanceDateRangeModule, 
        MultiSelectModule, FormsModule, CxAdvFiltersModule, CommonModule, 
        NgScrollbarModule,
        // DynamicDialogModule, 
        DialogModule, 
        DropdownModule 
    ],
    providers: [ CxTableService, CxDataGridService ], 
    declarations: [
        CxNestedRead,
        CxDatagridSettingsComponent,
        ExportModalComponent,
        ColumnSelectionDirective,
        EditModalComponent,
        AgentCallEvaluationFormComponent,
        AgentCallRecordingTranscriptComponent,
        ColumnEditDirective,
        AddEvaluationActionDirective,
        ShowTranscriptActionDirective,
        ViewSubmittedEvaluationActionDirective,
        ViewEvaluationActionDirective,
        ColumnResizeDirective,
        CxColumnFrozenDirective,
        CxColumnSortDirective,
        CxTableTemplate, 
        CxSplitCommaPipe,
        CxShowablePipe, 
        CxSplicePipe,
        CxFrozenColumn,
        CxDatagridComponent,
        EditViewNameModalComponent
    ],
    exports: [
        CxNestedRead,
        ExportModalComponent,
        ColumnSelectionDirective,
        ColumnEditDirective,
        AddEvaluationActionDirective,
        ShowTranscriptActionDirective,
        ViewSubmittedEvaluationActionDirective,
        ViewEvaluationActionDirective,
        EditModalComponent,
        AgentCallEvaluationFormComponent,
        AgentCallRecordingTranscriptComponent,
        ColumnResizeDirective,
        CxColumnFrozenDirective,
        CxColumnSortDirective,
        CxTableTemplate, 
        CxSplitCommaPipe, 
        CxSplicePipe,
        CxDatagridComponent,
        CxShowablePipe,
        CxDatagridSettingsComponent
    ]
})
export class CxDatagridModule {}